<template>    
    <div class="timeline-container">
        <b-row>
            <b-col cols="12">
                <div class="d-flex justify-content-between mx-4">
                    <label class="text-muted">{{ $t('timeline.lastChangesSubtitle') }}</label>
                    <b-button variant="success" size="sm" v-b-tooltip.hover :title="$t('timeline.refresh')" @click="getHistory()">
                        <md-icon icon="sync"/>
                    </b-button>
                </div>
                
                <div class="h-100 loader-container" v-if="loading">
                    <div class="loader text-center m-auto"></div>
                </div>
                
                <div class="container timeline" v-else>
                    <div class="timeline-item" v-for="(item, index) in timelineItems" :key="index">
                    <div :class="getClassDot(item.userId)" v-b-tooltip.hover :title="getChangeMessage(item.userId)"></div>
                        <div class="timeline-content">
                            <b-row>
                                <b-col 
                                    md="6" 
                                    lg="8">
                                    <div><small class="font-weight-bolder"># {{ item.id }}</small></div>
                                    <b-badge variant="info" v-if="item.action == 'new'">{{ $t('global.new') }}</b-badge>
                                    <b-badge variant="success" v-if="item.action == 'add'">{{ $t('global.add') }}</b-badge>
                                    <b-badge variant="warning" class="text-white text-uppercase" v-if="item.action == 'edit'">{{ $t('global.edit') }}</b-badge>
                                    <b-badge variant="danger" v-if="item.action == 'delete'">{{ $t('global.delete') }}</b-badge>

                                    <!-- Indicar último y primer cambio -->
                                    <b-badge 
                                        variant="primary" class="ml-1 text-uppercase" v-if="item.position == 'last'">
                                        {{ $t('timeline.lastChange') }}
                                    </b-badge>
                                    <b-badge variant="secondary" class="ml-1" v-if="item.position == 'first'">
                                        <md-icon icon="file_upload"/>
                                    </b-badge>
                                    {{ $t('timeline.changeType') }}: <small class="font-weight-bolder">{{ item.changeType }}</small>
                                    <div>
                                        <small class="font-weight-bolder">{{ $t('timeline.changes')}}: </small>
                                        <div v-for="(log, index) in item.changes" :key="index">
                                            <small>
                                                <md-icon icon="chevron_right"/>[{{ $t('history.' + log.input) }}]:
                                                <div class="ml-3">
                                                    <span class="text-muted"> {{ log.oldValue }} </span>
                                                    <md-icon icon="east"/>
                                                    {{ log.newValue }}
                                                </div>

                                            </small>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col  
                                    md="6"
                                    lg="4"
                                    class="text-left my-0">
                                    <div>
                                        <small class="font-weight-bolder">{{ $t('timeline.dateChange')}}:</small>
                                    </div>
                                    <div><small>{{ localTimeUser(item.creationDatetimeUTC) }} Local</small></div>
                                    <div><small>{{ formatTimeUTC(item.creationDatetimeUTC) }} UTC</small></div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
  </template>
  
  <script>

import moment from 'moment';

  export default {
    data() {
      return {
        loading: false,
        timelineItems: [],
        filters:{
            id: this.modelId,
            transportServiceId: this.transportServiceId
        },
      };
    },
    props: {
        modelId: {
			type : Number,
			required: false,
			default:-1
        },
        transportServiceId: {
            type : Number,
			required: false,
			default: null
        },
        model: Object
    },
    methods: {
        getHistory() {
            this.loading = true

            setTimeout(() => {
                this.$root.api.get('/history/timeline', {
                    params: {filters: this.filters}
                })
                .then(res => {
                    this.timelineItems = res.data.rows
                })
                .catch((err) => {
                    this.$root.handleRequestError(err)
                })
                .finally(() => {
                    this.loading = false
                })
            }, 500);

        },
        search() {
            this.getHistory()
        },
        getClassDot(userId) {
            // Edited by client
            if (userId == 14) return "timeline-dot dot-client"
            // Edited by system
            if (userId == 1) return "timeline-dot dot-system"

            return "timeline-dot"
        },
        getChangeMessage(userId) {
            if (userId == 14) return this.$t('timeline.clientChange')
            // Edited by system
            if (userId == 1) return this.$t('timeline.systemChange')

            return "Cambio aplicado"
        },
        localTimeUser(datetimeUTC) {
            var stillUtc = moment.utc(datetimeUTC);
            return moment(stillUtc).local().format('DD/MM/YYYY HH:mm');
        },
        formatTimeUTC(datetimeUTC) {
            return moment.utc(datetimeUTC).format('DD/MM/YYYY HH:mm');
        }
    },
    computed: {
        filtersClean(){
			return {
				id:  this.modelId,
				transportServiceId:this.filters.transportServiceId
			}
		},
		optsRides(){
			let rides = [{value: "", text: 'Todos' }];
			this.model.transportServices.forEach((ts)=>{
				if(ts.id>0){
					rides.push({value:ts.id,text:ts.serviceNumber})
				}
			})
			return rides;
		}
    },
    mounted() {
        this.getHistory()
    },
  };
  </script>
  
  <style scoped>

    .timeline {
        position: relative;
        padding: 10px 0px;
        margin: 20px 0px 20px 20px;
    }
    
    .timeline:before {
        content: '';
        position: absolute;
        left: 10px;
        top: 0;
        width: 2px;
        height: 100%;
        background: #ddd;
    }
    
    .timeline-item {
        position: relative;
        margin-bottom: 20px;
    }
    
    .timeline-dot {
        position: absolute;
        left: -2px;
        width: 25px;
        height: 25px;
        border: 3px solid darkgray;
        border-radius: 50%;
        background-color: #007bff;
        top: 10px;
    }

    .dot-client {
        background-color: rgb(194, 75, 194) !important;
    }

    .dot-system {
        background-color: rgb(211, 207, 211) !important;
    }

    .green {
        background-color: greenyellow;
    }

    .orange {
        background-color: orange;
    }
    
    .timeline-content {
        margin-left: 40px;
    }

    .title {
        font-size: 18px;
        font-weight: bolder;
    }

    .loader-container {
        margin-top: 200px
    }

    .loader {
        width: 35px;
        aspect-ratio: .75;
        --c:no-repeat linear-gradient(#007bff 0 0);
        background: 
            var(--c) 0%   100%,
            var(--c) 50%  100%,
            var(--c) 100% 100%;
        background-size: 20% 65%;
        animation: l8 1s infinite linear;
    }

    @keyframes l8 {
        16.67% {background-position: 0% 0%  ,50% 100%,100% 100%}
        33.33% {background-position: 0% 0%  ,50% 0%  ,100% 100%}
        50%    {background-position: 0% 0%  ,50% 0%  ,100% 0%  }
        66.67% {background-position: 0% 100%,50% 0%  ,100% 0%  }
        83.33% {background-position: 0% 100%,50% 100%,100% 0%  }
    }

  </style>
  